<div class="box shadow tax-card">
  <div class="header-card">
    <ap-badge
      [value]="security.securityStatusName ?? ''"
      [type]="
        this.security.securityStatusId === this.securityStatusItems.Approved
          ? 'success'
          : 'warning'
      "
      size="large"
      class="header-pill"
      icon=""></ap-badge>
    <h4 class="mb-0 tax-card-title header-title">
      <b>{{ security.transactionTypeName }}</b>
    </h4>
    <ap-checkbox
      (onChange)="onSelectionChange(security, $event)"
      class="ap-table-checkbox-container header-checkbox"
      [(ngModel)]="security.isChecked">
    </ap-checkbox>
  </div>
  <div class="row mt-4 tax-results-section">
    @if (security.securityStatusId !== securityStatusItems.PendingApproval) {
      @for (item of security.taxResults; track $index) {
        <div class="col-12 col-md-6 col-lg-6 p-3 d-flex flex-column">
          @if (item.rate !== null) {
            <div class="rate">{{ item.rate | formatRate }}%</div>

            <hr class="line-with-space w-25" />
            <p class="text-card">
              {{ item.transactionTypeName | parseToSentenceCase }}
            </p>
          } @else {
            <div class="rate">-</div>
            <hr class="line-with-space w-25" />
          }
        </div>
      }
    }
  </div>

  <div class="row mt-4 tax-card-summary">
    <div class="col-12 col-md-4 mb-3 mb-md-0 tax-card-summary-item">
      <b>{{ security.entityTypeName }}</b>
      <p class="text-card">
        {{ 'taxResult.taxResultView.cardDetail.entityType' | translate }}
      </p>
    </div>
    <div class="col-12 col-md-4 mb-3 mb-md-0 tax-card-summary-item">
      <b>{{ security.securityTypeName }}</b>
      <p class="text-card">
        {{ 'taxResult.taxResultView.cardDetail.securityType' | translate }}
      </p>
    </div>
    <div class="col-12 col-md-4 tax-card-summary-item">
      <b>
        {{ security.investingJurisdictionName }}
      </b>
      <p class="text-card">
        {{
          'taxResult.taxResultView.cardDetail.investingJurisdiction' | translate
        }}
      </p>
    </div>
  </div>

  <div class="row align-items-start mt-2 tax-card-footer">
    <div class="col-12 col-md-5 border-md-end pb-2 pb-md-0">
      <strong>
        {{ security.clientName }}
      </strong>
      <p class="text-card">
        {{ 'taxResult.taxResultView.cardDetail.client' | translate }}
      </p>
    </div>
    <div class="col-12 col-md-7 ps-md-3 pt-2 pt-md-0">
      @if (
        security.securityStatusId === securityStatusItems.Approved &&
        security.approvedBy
      ) {
        <div class="text-card my-2">
          {{ 'taxResult.approvedBy' | translate }}
          {{ security.approvedBy }}
        </div>
      }
      @if (security.securityStatusId === securityStatusItems.PendingApproval) {
        <div class="text-card my-2">
          {{ 'taxResult.attentionNeeded' | translate }}
        </div>
      }
      <p class="text-card">
        {{ 'taxResult.lastUpdated' | translate }}
        {{ security.modified | date: 'MM/dd/yyyy' }}
      </p>
    </div>
  </div>
</div>
